var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-card-template',{attrs:{"loaded":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }